import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initInterpreteSlice,
  setPropertiesInterprete,
  updateInterprete,
} from "../Slices/InterpreteSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  roles,
  userStatusSelect,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { TomTomMaps } from "../../../shared/components/CustomForm/TomTomMaps/TomTomMaps";

const { Content, Sider, Header, Footer } = Layout;

export function InterpreteDetail({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const { interprete, loading } = useSelector(state => state.interprete);

  const { user } = useContext(UserContext);

  const { init, clear } = initInterpreteSlice({ id });

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {
    info: { firstname, lastname, genre, phone },
    status,
    interpreteData: {
      abacusId,
      institutionsToAvoid,
      lastDateFormation,
      restrictionFollowPrestation,
      addressStart,
      address,
      languages,
      country,
      number,
      lastDateControl,
    },
    comment,
    email,
    subRoles,
  } = interprete;

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom",
          name: "info.lastname",
          value: lastname,
          type: "input",
          required: true,
          capitalize: true,
          col: 24,
        },
        {
          label: "Prénom",
          name: "info.firstname",
          value: firstname,
          capitalize: true,
          required: true,
          type: "input",
          col: 24,
        },
        {
          label: "Numéro d'interprète",
          name: "interpreteData.abacusId",
          value: abacusId,
          placeholder: "Numéro d'interprète (Abacus)",
          type: "number",
          precision: 0,
          min: 0,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: "Genre",
          name: "info.genre",
          placeholder: "Genre",
          value: genre,
          required: true,
          type: "select",
          selectContent: [
            { label: "Homme", value: "male" },
            { label: "Femme", value: "female" },
          ],
          col: 24,
        },
        {
          label: "E-mail",
          name: "email",
          normalize: value => value && value.toLowerCase(),
          value: email,
          type: "email",
          col: 24,
        },
        {
          label: "Téléphone",
          name: "info.phone",
          value: phone,
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 24,
        },
        // {
        //   label: <span style={{ visibility: "hidden" }}>.</span>,
        //   name: "email-link",
        //   type: "component",
        //   component: () => (
        //     <div className={"alignCenter"}>
        //       <a className={"link"}>Réinitialiser le mot de passe</a>
        //     </div>
        //   ),
        //   col: 6,
        // },
        // {
        //   required: true,
        //   label: "Adresse",
        //   name: "interpreteData.address",
        //   value: address,
        //   type: "google-adress",
        //   col: 24,
        // },
        {
          required: true,
          label: "Adresse de départ",
          name: "interpreteData.addressStart",
          value: addressStart,
          type: "google-adress",
          col: 24,
        },
        {
          col: 24,
          type: "component",
          name: "mapstomtom",
          noWrapper: true,
          component: ({ refForm }) => (
            <TomTomMaps
              keys={"interpreteData.addressStart"}
              refForm={refForm}
            />
          ),
        },
        // {
        //   label: "Pays d'origine",
        //   name: "interpreteData.country",
        //   value: country,
        //   multiple: false,
        //   showSearch: true,
        //   type: "select",
        //   selectContent: countryList,
        //   col: 24,
        // },
        {
          label: "Langues",
          name: "interpreteData.languages",
          value: languages,
          multiple: true,
          showSearch: true,
          type: "select",
          selectContent: languagesList.sort((a, b) =>
            a.label.localeCompare(b.label),
          ),
          col: 24,
        },
        // {
        //   label: "Dernière date de supervision",
        //   name: "interpreteData.lastDateControl",
        //   value: dayjs(lastDateControl),
        //   type: "date",
        //   col: 24,
        // },
        {
          label: "Mode d'interpretariat",
          required: true,
          name: "interpreteData.interpretingMode",
          type: "checkbox",
          value: interprete.interpreteData.interpretingMode,
          checkboxs: modeInterpretariat,
          col: 24,
        },
        {
          label: "Remarque",
          name: "comment",
          value: comment,
          visible: userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          type: "textarea",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Formations",
      children: [
        {
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          label: "Formations",
          name: "interpreteData.formations",
          type: "input",
          capitalize: false,
          col: 24,
        },
        {
          label: "Diplômes",
          name: "interpreteData.diplomas",
          type: "radios",
          radios: diplomas,
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: "Niveau",
          name: "interpreteData.level",
          type: "radios",
          radios: levels,
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
        {
          label: "Dernière date de formation",
          name: "interpreteData.lastDateFormation",
          value: dayjs(lastDateFormation),
          type: "date",
          showTime: false,
          disabled: !userHasLevel({
            not: {
              [roles.interprete]: "r", //
            },
          }),
          col: 24,
        },
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.interprete]: "r", //
        },
      })
        ? "Actions"
        : "",
      children: [
        loading !== true
          ? {
              label: "Ne pas proposer pour les clients suivants",
              name: "interpreteData.institutionsToAvoid",
              type: "dynamic-select",
              value: institutionsToAvoid,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              endPoint: "institutions",
              multiple: true,
              itemsCallBack: (institutions, form) => {
                try {
                  setReady(true);
                  formRef.current.setFieldValue(
                    "interpreteData.institutionsToAvoid",
                    institutionsToAvoid,
                  );
                } catch (e) {
                  console.log(e);
                }
              },
              itemCallback: item => {
                return {
                  key: item._id,
                  label: `${item.name}`,
                  value: item._id,
                };
              },
              col: 24,
            }
          : null,
        id !== "new"
          ? {
              label: "Accès autorisé",
              name: "status",
              value: status,
              required: true,
              visible: userHasLevel({
                not: {
                  [roles.interprete]: "r", //
                },
              }),
              type: "select",
              selectContent: userStatusSelect(),
              col: 24,
            }
          : null,
      ],
    },
    {
      parentLabel: userHasLevel({
        not: {
          [roles.interprete]: "r", //
        },
      })
        ? "Droits"
        : "",
      children: [
        {
          visible: userHasLevel({
            only: {
              [roles.admin]: "crud", //
            },
          }),
          label: "Restreindre la création de suivi pour cet interprète",
          name: "interpreteData.restrictionFollowPrestation",
          type: "checkbox-bool",
          value: id === "new" ? false : restrictionFollowPrestation,
          description: "L’interprète ne pourra plus créer de suivi.",
          col: 24,
        },
      ],
    },

    {
      children: [
        {
          label: id === "new" ? "Créer l'interprète" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };
  const onSubmitForm = async data => {
    if (id === "new") {
      data.role = roles.interprete;
    }

    await dispatch(setPropertiesInterprete(data));
    dispatch(updateInterprete());
  };

  const sendEmail = async () => {
    let caller = await http.post("/notifications/invitation", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: `Email envoyé avec succès`,
      });
  };

  return (
    <>
      <Typography.Title level={3} className={""}>
        {id === user._id
          ? "Mon compte interprète"
          : routes.interpretes(id).detail.title}
      </Typography.Title>
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <ActionDropdown
            rule={{
              only: {
                [roles.admin]: "crud",
                [roles.permanance]: "crud",
              },
            }}
          >
            <ActionRoleSpecific only={[roles.admin, roles.permanance]}>
              <a onClick={sendEmail}>Envoyer un email d'invitation</a>
            </ActionRoleSpecific>
          </ActionDropdown>

          <CustomForm
            disabled={
              !userHasLevel({
                only: {
                  [roles.admin]: "crud", //
                  [roles.permanance]: "crud", //
                },
              })
            }
            initialValues={interprete}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
